import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const showJobSlice = createSlice({
  name: 'SHOW_JOB',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetToInitials: (state) => {
      state = { ...initialState };
    },
  },
});

//REDUCER
export default showJobSlice.reducer;

// ACTIONS
export const { loading, success, failure, resetToInitials } = showJobSlice.actions;

/// SELECTORS
export const selectIsLoading = (state: RootState) => state.ui.job.show.isLoading;

export const selectSuccess = (state: RootState) => state.ui.job.show.success;

export const selectError = (state: RootState) => state.ui.job.show.error;
